

<script lang="ts">
  import type { PermissionState } from "@kontextwerk/control-web-frame/logic/permissions/model"
  import type { OrganizationDetail as OrganizationDetailApi } from "@kontextwerk/control-web-client"
  import type { CustomersViewFrameContext } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"
  import type { AddressesTabContext } from "./navigation"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import CustomerUnitsSection from "./_modules/customer-units-section"
  import type { CustomersViewFrameContext as ViewFrameContext } from "../../context"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: ViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    permissions: viewFrameContext.permissions,
    organization: viewFrameContext.organization,
    effectiveOrganizationId: viewFrameContext.effectiveOrganizationId,
    customer: viewFrameContext.customer,
    properties: viewFrameContext.properties,
    propertyLinks: viewFrameContext.propertyLinks,
    isFreeTrialExperience: viewFrameContext.isFreeTrialExperience,
    trialRestrictionsActive: viewFrameContext.trialRestrictionsActive,
    loading: viewFrameContext.loading,
    error: viewFrameContext.error,
    onRetry: viewFrameContext.onRetry,
    onAddressesChanged: viewFrameContext.onAddressesChanged,
    currentUserRole: viewFrameContext.currentUserRole,
    currentUserOrganizationId: viewFrameContext.currentUserOrganizationId,
  }))

  const canEditCustomer = $derived.by(() => {
    const belongsToOrganization = Boolean(
      pageContext.currentUserOrganizationId &&
      pageContext.organization?.id &&
      pageContext.currentUserOrganizationId === pageContext.organization.id,
    )

    return Boolean(
      !pageContext.trialRestrictionsActive &&
      !pageContext.customer?.archived_at &&
      (pageContext.permissions.isSuper || belongsToOrganization),
    )
  })

  const tabContext = $derived.by<AddressesTabContext>(() => ({
    ...pageContext,
    canEditCustomer,
  }))
</script>

{#snippet addressesContent(ctx: AddressesTabContext)}
  {#if ctx.loading}
    <div class="state-block">
      <p>Liegenschaften werden geladen…</p>
    </div>
  {:else if ctx.error}
    <div class="state-block">
      <p>{ctx.error}</p>
      <CTA type="secondaryButton" content="Erneut versuchen" onClick={ctx.onRetry} />
    </div>
  {:else if ctx.customer}
    <CustomerUnitsSection
      properties={ctx.properties}
      propertyLinks={ctx.propertyLinks}
      organizationId={ctx.effectiveOrganizationId ?? ""}
      customer={ctx.customer}
      canEdit={ctx.canEditCustomer}
      onChanged={ctx.onAddressesChanged}
    />
  {/if}
{/snippet}

{#if activeTab === "addresses"}
  {@render addressesContent(tabContext)}
{/if}

<style lang="less">
  .state-block {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
</style>
